<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-80" @mousedown.stop="">
          <div class="modal-body m-0" style="overflow-y: auto;" :style="{maxHeight: getMaxHeightClient() + 'px'}">
            <div v-if="isScanQRCodeActive">
              <qr-code-stream :key="_uid" :track="trackingQRCode" :camera="camera" @decode="onDecode" @init="onInit">
                <div v-if="scanningEnd" class="scan-end">
                  {{ $t('creation_forms.scn_qr_code_sccs') }}
                </div>
                <div v-if="scanningPending" class="center scan-pending text-center">
                  <b-spinner></b-spinner>
                  <strong>{{ $t('creation_forms.scn_qr_code_pndg') }}</strong>
                </div>
                <div v-if="loading" class="center text-center scan-pending">
                  <b-spinner></b-spinner>
                  <strong>{{ $t('creation_forms.scn_qr_code_ldng') }}</strong>
                </div>
                <div v-if="errorNoCamera" class="center text-center scan-pending">
                  <span class="fa-stack fa-2x">
                    <i class="fa fa-camera fa-stack-1x"></i>
                    <i class="fa fa-ban fa-stack-2x text-danger"></i>
                  </span>
                  <strong class="text-danger">{{$t('errors.no_camera')}}</strong>
                </div>
              </qr-code-stream>
            </div>
            <button round class="button-action firstButtonMarginTop" @click="quitScanner()">{{ $t('common.cncl') }}</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import {QrcodeStream} from 'vue-qrcode-reader'

export default {
  name: 'PopupScannerQRCode',
  components: {
    'qr-code-stream': QrcodeStream
  },
  props: {
    content: {
      type: String
    }
  },
  data: () => {
    return {
      camera: 'auto',
      errorNoCamera: false,
      hasQrStopScanning: undefined,
      isScanQRCodeActive: true,
      loading: false,
      qrCodeContent: ''
    }
  },
  computed: {
    scanningPending () {
      return this.hasQrStopScanning === undefined && this.camera === 'off'
    },
    scanningEnd () {
      return this.hasQrStopScanning === true
    }
  },
  created () {
    window.addEventListener('resize', this.changeMaxHeightClient)
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  methods: {
    changeMaxHeightClient () {
      let maxHeight = document.querySelector('body').clientHeight
      document.querySelector('.modal-container').setAttribute('style', 'overflow-y:auto;max-height:' + maxHeight + 'px')
    },
    getMaxHeightClient () {
      return document.querySelector('body').clientHeight
    },
    async onDecode (decodedString) {
      this.qrCodeContent = decodedString
      this.turnCameraOff()

      await this.timeout(1000) // Permet de ne pas faire disparaitre l'IHM d'un coup pour plus de clarté pour l'utilisateur
      this.hasQrStopScanning = true
      await this.timeout(1000)

      this.isScanQRCodeActive = false
      this.hasQrStopScanning = undefined
      this.turnCameraOn()
      this.$emit('close')
      console.log('emit')
      this.$bus.$emit('close-popup-scanner-qr-code', this.content + ';' + decodedString)
    },
    async onInit (promise) {
      this.loading = true
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotFoundError') {
          this.errorNoCamera = true
        }
      } finally {
        this.loading = false
        this.resetValidationState
      }
    },
    quitScanner () {
      this.isScanQRCodeActive = false
      this.$emit('close')
    },
    resetValidationState () {
      this.hasQrStopScanning = undefined
    },
    timeout (ms) {
      return new Promise(resolve => {
        window.setTimeout(resolve, ms)
      })
    },
    trackingQRCode (detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const { boundingBox: { x, y, width, height } } = detectedCode

        ctx.lineWidth = 3
        ctx.strokeStyle = 'red'
        ctx.strokeRect(x, y, width, height)
      }
    },
    turnCameraOn () {
      this.camera = 'auto'
    },
    turnCameraOff () {
      this.camera = 'off'
    }
  }
}
</script>
<style scoped>
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.scan-end,
.scan-pending {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, .8);
  text-align: center;
  font-weight: bold;
  font-size: 1.4rem;
  padding: 10px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}
.scan-end {
  color: green;
}
</style>
